import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, switchMap } from 'rxjs';
import { AppConfigHttpService } from 'src/app/services/http/app-config.http.service';
import { selectClientDataConsumptionInGb } from 'src/app/shared/store/clients/clients.selectors';
import { selectClientCode } from 'src/app/shared/store/router/router.selectors';
import { SaturatedStorageComponent } from '../saturated-storage/saturated-storage.component';

@Directive({
  selector: '[showIfStorageSpaceAvailable]',
  standalone: true,
})
export class ShowIfStorageSpaceAvailableDirective {
  private readonly store = inject(Store);
  private readonly configurationService = inject(AppConfigHttpService);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly container = inject(ViewContainerRef);

  @Input()
  set showIfStorageSpaceAvailable(display: boolean) {
    this.store
      .select(selectClientCode)
      .pipe(
        first(),
        switchMap((clientCode) => this.store.select(selectClientDataConsumptionInGb(clientCode))),
      )
      .subscribe((dataConsumption) => {
        const lockQuotient = this.configurationService.configuration.paywall.lockQuotient;
        this.createContent((dataConsumption.used * 100) / dataConsumption.total < lockQuotient);
      });
  }

  createContent(display: boolean): void {
    this.container.clear();
    if (display) {
      this.container.createEmbeddedView(this.templateRef);
    } else {
      this.container.createComponent(SaturatedStorageComponent);
    }
  }
}
